import React from 'react';
import ListItem from '../../list-items/ListItem';

import './UserManagerList.css';

const InputText = React.memo(props=>{
  return (
    <input
      name={props.name}
      type={props.type}
      className={props.className}
      id={props.id}
      size={props.size}
      onChange={props.onChange}
      value={props.value}
      placeholder={props.placeholder}
    />
  )
})

const UserManagerList = (props) => {
  return(
    <>
      <div className="userListTit">USER LIST</div>
      <div className="userSearch">
        <InputText placeholder="검색할 E-mail 입력" onChange={props.handleSearchInput} value={props.userFilter} name="textfield" type="text" className="box" id="textfield" size="25" />
        <a onClick={()=>{
          props.handleSearchBtn(JSON.stringify(props.userLabelData))
        }} className="button purple_line" style={{marginLeft: "4px"}}>검색</a>
      </div>
      <div className="userListGroup">
        <div className="overflow-component">
          {props.filteredArray.info.map( (item, index) => 
            <div className="userGroup">
              <ListItem expFilter={props.expFilter} type={props.filteredArray.type} key={item.name+index} item={item} index={index} handleClick={props.handleClick} />
            </div>
          )}
          {props.filteredArray.nullLabelItem.map( (item, index) => 
            <ListItem expFilter={props.expFilter} handleClick={props.handleClick} type={props.filteredArray.nullLabelItemType} key={item.name+index} item={item} index={index} />
          )}
        </div>
      </div>
    </>
  )
}

export default UserManagerList;